import { Component } from '@angular/core';
import { PopupContinents } from './popup-continents.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './popup-continents-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class PopupContinentsComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: PopupContinents[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }
}
